import { createColDef } from '@fortem-monorepo/react-ag'

import { TopLevelBucketIdCellEditor } from '@/ag-grid/columns/top-level-bucket-id/cell-editor'
import { TopLevelBucketIdCellRenderer } from '@/ag-grid/columns/top-level-bucket-id/renderer'

export const top_level_bucket_id = createColDef({
  field: 'top_level_bucket_id',
  headerName: 'Top Level Bucket',
  cellRenderer: TopLevelBucketIdCellRenderer,
  cellEditor: TopLevelBucketIdCellEditor,
  width: 100,
})
